/* DBS product showcase
 * Six slots. Each slot shows a random product that flies in, changes size
 * and rotates slowly for N seconds (default 10), flies out, and a different
 * product takes its place. White photo backgrounds are knocked out to
 * transparent (edge flood-fill, so white inside a product is kept).
 */
(function () {
  'use strict';

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var ENTER = 900, EXIT = 800;
  var CACHE_MAX = 14;

  function abs(u) { return u && u.indexOf('//') === 0 ? 'https:' + u : u; }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function loadImg(src) {
    return new Promise(function (res, rej) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); };
      im.onerror = rej;
      im.src = src;
    });
  }

  /* Remove white that touches the photo edge. Throws if the canvas is tainted. */
  function knockout(im, T) {
    var w = im.naturalWidth, h = im.naturalHeight;
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(im, 0, 0);
    var d = x.getImageData(0, 0, w, h);
    var a = d.data, n = w * h;

    function isBg(p) {
      var i = p * 4;
      return a[i + 3] < 12 || (a[i] >= T && a[i + 1] >= T && a[i + 2] >= T);
    }
    var seen = new Uint8Array(n);
    var st = new Int32Array(n);
    var sp = 0;
    function push(p) { if (!seen[p] && isBg(p)) { seen[p] = 1; st[sp++] = p; } }

    var i, j, p, px;
    for (i = 0; i < w; i++) { push(i); push((h - 1) * w + i); }
    for (j = 0; j < h; j++) { push(j * w); push(j * w + w - 1); }
    while (sp) {
      p = st[--sp]; px = p % w;
      if (px > 0) push(p - 1);
      if (px < w - 1) push(p + 1);
      if (p >= w) push(p - w);
      if (p < n - w) push(p + w);
    }
    for (p = 0; p < n; p++) if (seen[p]) a[p * 4 + 3] = 0;

    // soften the fringe: pixels touching the removed area that are nearly white fade out
    var SOFT = 34;
    for (p = 0; p < n; p++) {
      if (seen[p]) continue;
      px = p % w;
      var edge = (px > 0 && seen[p - 1]) || (px < w - 1 && seen[p + 1]) ||
                 (p >= w && seen[p - w]) || (p < n - w && seen[p + w]);
      if (!edge) continue;
      var k = p * 4;
      var m = Math.min(a[k], a[k + 1], a[k + 2]);
      if (m > T - SOFT) {
        var al = Math.round(255 * Math.max(0, (T - m) / SOFT));
        if (al < a[k + 3]) a[k + 3] = al;
      }
    }
    x.putImageData(d, 0, 0);
    return c;
  }

  function Showcase(root) {
    var self = this;
    this.root = root;
    root.setAttribute('data-ready', '1');

    var data = root.querySelector('script.dbsx-data');
    try { this.items = JSON.parse(data ? data.textContent : '[]'); } catch (e) { this.items = []; }
    if (!this.items.length) return;

    this.hold = (parseFloat(root.getAttribute('data-hold')) || 10) * 1000;
    this.knock = root.getAttribute('data-knockout') !== 'false';
    this.T = parseInt(root.getAttribute('data-threshold'), 10) || 236;
    this.active = new Set();
    this.cache = {};
    this.cacheOrder = [];
    this.paused = false;

    this.slots = Array.prototype.map.call(root.querySelectorAll('.dbsx-slot'), function (el) {
      return {
        el: el,
        media: el.querySelector('.dbsx-slot__media'),
        cap: el.querySelector('.dbsx-slot__cap'),
        t: el.querySelector('.dbsx-slot__t'),
        p: el.querySelector('.dbsx-slot__p'),
        anim: null, capAnim: null, last: -1
      };
    });

    function setPaused(v) {
      self.paused = v;
      self.slots.forEach(function (s) {
        [s.anim, s.capAnim].forEach(function (an) {
          if (!an) return;
          try { v ? an.pause() : an.play(); } catch (e) {}
        });
        if (s.bgs) s.bgs.forEach(function (el) {
          if (el.tagName !== 'VIDEO') return;
          if (v) el.pause(); else if (el.classList.contains('is-on')) { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
        });
      });
    }
    document.addEventListener('visibilitychange', function () { setPaused(document.hidden || self.offscreen); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        self.offscreen = !es[0].isIntersecting;
        setPaused(document.hidden || self.offscreen);
      }).observe(root);
    }

    var bgList = [];
    try { bgList = JSON.parse((root.querySelector('script.dbsx-bgs') || {}).textContent || '[]'); } catch (e) {}
    if (bgList.length) this.setupBgs(bgList);

    this.slots.forEach(function (s, i) {
      setTimeout(function () { self.cycle(s); }, i * 1100 + Math.random() * 600);
    });
  }

  /* ---------- square backgrounds (gif / image / mp4), optional rotation ---------- */
  Showcase.prototype.setupBgs = function (list) {
    var self = this, root = this.root;
    var rotate = root.getAttribute('data-bg-rotate') === 'true';
    var secs = Math.max(1, parseFloat(root.getAttribute('data-bg-seconds')) || 1);
    var shuffle = root.getAttribute('data-bg-shuffle') !== 'false';
    root.style.setProperty('--dbsx-dim', String((parseFloat(root.getAttribute('data-bg-dim')) || 0) / 100));
    this.slots.forEach(function (s, i) {
      var holder = s.el.querySelector('.dbsx-slot__bg');
      if (!holder) return;
      s.bgs = list.map(function (b) {
        var el;
        if (b.v) {
          el = document.createElement('video');
          el.muted = true; el.loop = true; el.playsInline = true;
          el.setAttribute('muted', ''); el.setAttribute('playsinline', '');
          el.preload = 'metadata';
          el.src = abs(b.v);
        } else {
          el = document.createElement('img');
          el.alt = ''; el.decoding = 'async';
          el.src = abs(b.i);
        }
        holder.appendChild(el);
        return el;
      });
      s.bgIdx = shuffle ? (Math.random() * list.length) | 0 : i % list.length;
      self.showBg(s);
    });
    if (rotate && list.length > 1) {
      setInterval(function () {
        if (self.paused) return;
        self.slots.forEach(function (s) {
          if (!s.bgs) return;
          if (shuffle && list.length > 2) {
            var n;
            do { n = (Math.random() * list.length) | 0; } while (n === s.bgIdx);
            s.bgIdx = n;
          } else s.bgIdx = (s.bgIdx + 1) % list.length;
          self.showBg(s);
        });
      }, secs * 1000);
    }
  };
  Showcase.prototype.showBg = function (s) {
    s.bgs.forEach(function (el, k) {
      var on = k === s.bgIdx;
      el.classList.toggle('is-on', on);
      if (el.tagName === 'VIDEO') {
        if (on && !this.paused) { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!on) el.pause();
      }
    }, this);
  };

  Showcase.prototype.pick = function (slot) {
    var n = this.items.length, free = [], i;
    for (i = 0; i < n; i++) if (!this.active.has(i) && i !== slot.last) free.push(i);
    if (!free.length) for (i = 0; i < n; i++) free.push(i);
    return free[(Math.random() * free.length) | 0];
  };

  Showcase.prototype.node = function (idx) {
    var self = this;
    if (this.cache[idx]) return this.cache[idx];
    var it = this.items[idx];

    function plain() {
      var im = new Image();
      im.alt = it.a || it.t;
      im.decoding = 'async';
      im.draggable = false;
      im.src = abs(it.i);
      return im;
    }
    var pr = loadImg(abs(it.i)).then(function (im) {
      if (self.knock) {
        try {
          var c = knockout(im, self.T);
          c.setAttribute('role', 'img');
          c.setAttribute('aria-label', it.a || it.t);
          return c;
        } catch (e) { /* tainted canvas: fall through to plain image */ }
      }
      return plain();
    }, function () { return plain(); });

    this.cache[idx] = pr;
    this.cacheOrder.push(idx);
    // keep memory in check
    while (this.cacheOrder.length > CACHE_MAX) {
      var drop = -1, k;
      for (k = 0; k < this.cacheOrder.length; k++) {
        if (!this.active.has(this.cacheOrder[k])) { drop = k; break; }
      }
      if (drop < 0) break;
      delete this.cache[this.cacheOrder.splice(drop, 1)[0]];
    }
    return pr;
  };

  Showcase.prototype.cycle = async function (s) {
    var idx = this.pick(s);
    this.active.add(idx);
    s.last = idx;
    var it = this.items[idx];

    var node = await this.node(idx);
    s.media.textContent = '';
    s.media.appendChild(node);
    s.el.href = it.u;
    s.el.setAttribute('aria-label', it.t);
    s.t.textContent = it.t;
    s.p.textContent = it.p;
    s.el.classList.toggle('is-gone', it.av === false);

    var edges = [{ x: -1, y: 0 }, { x: 1, y: 0 }, { x: 0, y: -1 }, { x: 0, y: 1 }];
    var inDir = edges[(Math.random() * 4) | 0];
    var outDir = edges[(Math.random() * 4) | 0];
    var drift = function (d) { return { x: d.x * 150 + (d.y ? rnd(-30, 30) : 0), y: d.y * 150 + (d.x ? rnd(-30, 30) : 0) }; };
    var a = drift(inDir), b = drift(outDir);

    var spin = reduce ? 0 : (Math.random() < 0.5 ? -1 : 1) * rnd(12, 26);   // degrees over the hold
    var r0 = reduce ? 0 : rnd(-14, 14);
    var s0 = rnd(0.62, 0.8), s1 = rnd(0.9, 1.12), s2 = rnd(0.68, 1.02);       // size changes while it stays
    var total = ENTER + this.hold + EXIT;
    var o1 = ENTER / total, o2 = (ENTER + this.hold) / total;

    var tf = function (tx, ty, rot, sc) {
      return 'translate(' + tx + '%,' + ty + '%) rotate(' + rot + 'deg) scale(' + sc + ')';
    };
    var kf = [
      { transform: tf(a.x, a.y, r0 - 80, 0.3), opacity: 0, offset: 0, easing: 'cubic-bezier(.2,.9,.25,1)' },
      { transform: tf(0, 0, r0, s0), opacity: 1, offset: o1, easing: 'ease-in-out' },
      { transform: tf(0, 0, r0 + spin / 2, s1), opacity: 1, offset: (o1 + o2) / 2, easing: 'ease-in-out' },
      { transform: tf(0, 0, r0 + spin, s2), opacity: 1, offset: o2, easing: 'cubic-bezier(.6,0,.9,.4)' },
      { transform: tf(b.x, b.y, r0 + spin + 70, 0.3), opacity: 0, offset: 1 }
    ];
    if (s.anim) s.anim.cancel();
    if (s.capAnim) s.capAnim.cancel();
    s.anim = s.media.animate(kf, { duration: total, fill: 'forwards' });
    s.capAnim = s.cap.animate([
      { opacity: 0, offset: 0 },
      { opacity: 1, offset: Math.min(o1 + 0.02, 0.2) },
      { opacity: 1, offset: o2 },
      { opacity: 0, offset: 1 }
    ], { duration: total, fill: 'forwards' });
    if (this.paused) { s.anim.pause(); s.capAnim.pause(); }

    try { await s.anim.finished; } catch (e) { /* cancelled */ }
    this.active.delete(idx);
    await sleep(rnd(150, 700));
    this.cycle(s);
  };

  function initAll() {
    var roots = document.querySelectorAll('.dbsx-show:not([data-ready])');
    for (var i = 0; i < roots.length; i++) new Showcase(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
